import $ from 'jquery';
import moment from 'moment';

export const defaultOptions = {
	showClear: true,
	showTodayButton: true,
	useCurrent: false,
	icons: {
		time: 'fa fa-clock-o',
		date: 'fa fa-calendar',
		up: 'fa fa-chevron-up',
		down: 'fa fa-chevron-down',
		previous: 'fa fa-chevron-left',
		next: 'fa fa-chevron-right',
		today: 'fa fa-calendar-check-o',
		clear: 'fa fa-trash-o',
		close: 'fa fa-close'
	}
};

export function setDateTimePicker(element, format) {
	let verticalMode = $(element).data('vertical') || 'auto';

	
	if (!format) {
		format = getDateTimePickerFormat(element);
	}

	var minDate = false;
	var maxDate = false;
	if($(element).attr('data-min-date')){
		minDate = $(element).attr('data-min-date');
	}
	if($(element).attr('data-max-date')){
		maxDate = $(element).attr('data-max-date');
	}
	const options = {
		...defaultOptions,
		format: format,
		locale: moment.locale(),
		minDate: minDate,
		maxDate: maxDate,
		widgetPositioning: {
			vertical: verticalMode
		},
	};
	$(element).datetimepicker(options);
}

function getDateTimePickerFormat(element) {
	const $t = $(element);
	let format = "L LT";
	if ($t.hasClass("dtp-date")) {
		format = "L";
	} else if ($t.hasClass("dtp-time")) {
		format = "LT";
	}
	return format;
}

export default function () {

	$('input[data-provider=datepicker]', this)
	.each(function (i, e) {
		setDateTimePicker(e);
	});
	$("div[data-provider=datepicker]", this)
		.each(function (i, e) {
			const $i1 = $("input:first", e);
			const $i2 = $("input:last", e);

			const minDate = $i1.val();
			const maxDate = $i2.val();

			const format = getDateTimePickerFormat(e);
			setDateTimePicker($i1, format);
			setDateTimePicker($i2, format);

	        const disableFromLimitAttr = $(this).attr("data-disable-from-limit");
	        const enableFromLimit = (typeof disableFromLimitAttr === typeof undefined || disableFromLimitAttr === false);

			// initial range
			if (minDate != '')
			{
				$i2.data("DateTimePicker").minDate(minDate);
			}
	        if (maxDate != '' && enableFromLimit)
			{
				$i1.data("DateTimePicker").maxDate(maxDate);
			}

			$i1.on("dp.change", function (e) {
				$i2.data("DateTimePicker").minDate(e.date);
			});
	        if (enableFromLimit) {
	            $i2.on("dp.change", function (e) {
	                $i1.data("DateTimePicker").maxDate(e.date);
	            });
	        }
		});
}



// WEBPACK FOOTER //
// ./node_modules/linksoft/src/initializers/datepicker.js